import { isNotEmptyString } from "@mapmycustomers/shared";

const appendSignature = (htmlContent: string, signatureText: string): string => {
  if (isNotEmptyString(signatureText)) {
    return `<div>${htmlContent}</div><div><div></div><div></div>${signatureText}</div>`;
  }
  return htmlContent;
};

export default appendSignature;
